module.exports = __webpack_public_path__ + "r-v3/img/clap.3c419d94.svg";